
import { spacing } from '../../style/theme';
import { projectText } from '../projects/ProjectRenderer';

export default function DefaultSignature() {
  return (
    <>
      <p css={[projectText, { marginTop: spacing.large }]}>
        That's all for this update! As always, thank you for your support.
        <br />— the Wren team 🧡
      </p>
    </>
  );
}
